import { Action, createReducer, on } from '@ngrx/store';
import { ScanQROrderState } from './scan-qr-order.state';
import {
  ClearStateAction,
  getChooseLocationAction,
  getChooseLocationErrorAction,
  getChooseLocationSuccessAction,
  setOrderFromSiteAction,
  setSiteIDAction,
} from './scan-qr-order.actions';

const initialState = new ScanQROrderState();

const reducer = createReducer(
  initialState,

  on(getChooseLocationAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getChooseLocationSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(getChooseLocationErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(setSiteIDAction, (state, { siteId }) => {
    const newState = { ...state };
    newState.siteId = siteId;
    return newState;
  }),
  on(setOrderFromSiteAction, (state, { orderFromSite }) => {
    const newState = { ...state };
    newState.orderFromSite = orderFromSite;
    return newState;
  }),
  on(ClearStateAction, (state, payload) => {
    const newState = { ...state };
    switch (payload.actionType) {
      case 'orderFromSite':
        newState.orderFromSite = null;
        break;
      case 'siteId':
        newState.siteId = null;
        break;
      default:
        break;
    }
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  })
);

export function ScanQROrderReducer(state: ScanQROrderState | null, action: Action) {
  return reducer(state, action);
}
